export const accountState = {
  pending: 'pending',
  validated: 'validated',
  error: 'error',
  unknown: 'unknown',
};

export const manageAccountColumns = {
  objectId: 'objectId',
  organizationObjectId: 'organizationObjectId',
  awsAccountAlias: 'awsAccountAlias',
  awsAccountId: 'awsAccountId',
  awsAccountRoleArn: 'awsAccountRoleArn',
  awsAccountRoleExternalId: 'awsAccountRoleExternalId',
  awsAccountIsActivated: 'awsAccountIsActivated',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  awsAccountIsValidated: 'awsAccountIsValidated',
  awsAccountRegion: 'awsAccountRegion',
};

export const columnsData = [
  {
    dataFieldName: manageAccountColumns.awsAccountIsActivated,
    label: 'Status',
    sortable: false,
    width: '4rem',
  },
  {
    dataFieldName: manageAccountColumns.awsAccountId,
    label: 'Account Number',
    sortable: false,
    width: '1fr',
  },
  {
    dataFieldName: manageAccountColumns.awsAccountAlias,
    label: 'Account Alias',
    sortable: false,
    width: '1fr',
  },
  {
    dataFieldName: manageAccountColumns.awsAccountRegion,
    label: 'Region',
    sortable: false,
    width: '1fr',
  },
  {
    dataFieldName: manageAccountColumns.updatedAt,
    label: 'Date Activated',
    sortable: false,
    width: '1fr',
  },
  {
    dataFieldName: manageAccountColumns.objectId,
    label: ' ',
    sortable: false,
    width: '1fr',
  },
];

export const icons = {
  [accountState.validated]: 'checkmarkCircle',
  [accountState.pending]: 'pendingCircle',
  [accountState.error]: 'error',
  [accountState.unknown]: undefined,
};

export const kbArticles = {
  removeAwsAccounts: 'https://support.jumpcloud.com/s/article/Removing-AWS-Accounts-in-Cloud-Insights',
};

export default {
  accountState,
  columnsData,
  icons,
  kbArticles,
  manageAccountColumns,
};
